import { TMro } from 'types/auth-token.types';
import { IUserWizardStatuses } from 'types/users';
import { GetMyWorkspacesParams, IMyWorkspaceItem } from 'types/workspace.types';
import { memberApiV2 } from '@lib/api/member-api-v2';
import { GetUserNotesParams, INotesRes } from 'types/notes';

export function updateUserRole(roles: TMro[]) {
  return memberApiV2.request('/client/profile/update-third-party-role', {
    method: 'PATCH',
    data: { roles },
  });
}

export function updateProfile(data: any) {
  return memberApiV2.request('/client/profile', {
    method: 'PATCH',
    data,
  });
}

export function updateAddresses(address: any[]) {
  return memberApiV2.request('/client/profile/address', {
    method: 'PUT',
    data: address,
  });
}

export function getUserWizardsStatus() {
  return memberApiV2.request<{ data: IUserWizardStatuses }>('/management/public/profile/wizard', {
    method: 'GET',
  });
}

export function updateUserWizardsStatus(statuses: Partial<IUserWizardStatuses>) {
  return memberApiV2.request<{ data: IUserWizardStatuses }>('/management/public/profile/wizard', {
    method: 'PATCH',
    data: statuses,
  });
}

export function getMyExpertise() {
  return memberApiV2.request<{
    data: {
      code: string;
      name: string;
      from: string;
    }[];
  }>('/management/public/profile/expertise');
}

export function createExpertise(expertiseCode: string, from: string) {
  return memberApiV2.request('/management/public/profile/expertise', {
    method: 'POST',
    data: { expertiseCode, from },
  });
}

export function deleteExpertise(expertiseCode: string) {
  return memberApiV2.request(`/management/public/profile/expertise/${expertiseCode}`, {
    method: 'DELETE',
  });
}

export function getMyWorkspaces(providerId: string, params: GetMyWorkspacesParams) {
  return memberApiV2.request<{ data: IMyWorkspaceItem[] }>('/management/private/user/workspaces', {
    params,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function getClientNotesById(providerId: string, params: GetUserNotesParams) {
  return memberApiV2.request<{ data: INotesRes }>(
    '/management/private/medical-data/note/get-notes',
    {
      method: 'GET',
      params,
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function createClientNote(clientId: string, note: string, reference: string) {
  return memberApiV2.request('/management/private/medical-data/note/create', {
    method: 'POST',
    data: { note, reference },
    params: {
      clientId,
    },
  });
}

export function getHilbiUser() {
  return memberApiV2.request<{ data: { jabberId: string; id: string } }>(
    '/management/public/user/hilbi-user',
    {
      method: 'GET',
    },
  );
}
